import { useTranslation } from "react-i18next";
import { Button, Spinner } from "@boligportal/bricks-ui";
import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { AlertState } from "~/components/bricks/AlertState";
import { tryRefreshTokenUntilPermission } from "~/hooks/useCustomer";
import { TIER_DATA } from "~/routes/(restricted)/-components/subscription-tiers/tier-data";
import { checkoutSearchSchema } from "~/routes/(restricted)/checkout";

export const Route = createFileRoute("/(restricted)/checkout/callback")({
  validateSearch: checkoutSearchSchema,
  beforeLoad: ({ search }) => ({ search }),
  loader: async ({
    context: {
      authClient,
      search: { product, from },
    },
  }) => {
    const tier = TIER_DATA.get(product);

    if (!tier) {
      throw new Error(`Unsupported tier for ${product}.`);
    }

    // Keep refreshing access_token, until the JWT holds the targetAppPermission.
    await tryRefreshTokenUntilPermission(authClient, tier.targetAppPermission);

    const to = from?.startsWith("/") ? from : "/";

    throw redirect({
      to,
      replace: true,
      resetScroll: true,
      viewTransition: false,
      ignoreBlocker: true,
    });
  },
  pendingComponent: () => {
    const { t } = useTranslation(["checkout"]);

    return (
      <div className="flex h-full items-center justify-center gap-2">
        <Spinner className="text-primary-administration" />
        {t("callback.awaiting_access.description")}
      </div>
    );
  },
  errorComponent: () => {
    const { t } = useTranslation(["checkout"]);

    return (
      <AlertState
        className="h-full w-full items-center justify-center sm:w-1/2"
        headline={t("callback.error_page.headline")}
        description={t("callback.error_page.description")}
        renderPrimaryAction={() => (
          <Button
            asChild
            color="primary-administration"
          >
            <a
              href={t("callback.error_page.cta.support.url")}
              target="_blank"
            >
              {t("callback.error_page.cta.support.text")}
            </a>
          </Button>
        )}
        renderSecondaryAction={() => (
          <Button
            asChild
            color="primary-administration"
            variant="text"
          >
            <Link
              to="/"
              replace
              reloadDocument
            >
              {t("callback.error_page.cta.reload.text")}
            </Link>
          </Button>
        )}
      />
    );
  },
});
